import React, { Component } from "react";
import { Row, Col, Form, FormGroup, Input, Button } from "reactstrap";
import LessonCard from "../LessonCard";
import Filter from "../Filter";
export default class AddDecks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: "",
      decks: [
        {
          code: "deck-code",
          name: "Name Deen",
          type: "Deck",
          nodes: "Writers Goal",
          tags: "get-em-tiger",
          card: "20"
        },
        {
          code: "deck-code",
          name: "Gullolo Mama",
          type: "Deck",
          nodes: "Writers Goal",
          tags: "get-em-tiger",
          card: "20"
        },
        {
          code: "deck-code",
          name: "Deck Name",
          type: "Deck",
          nodes: "Writers Goal",
          tags: "get-em-tiger",
          card: "20"
        }
      ]
    };
  }
  onChg = ({ target }) => this.setState({ [target.name]: target.value });

  render() {
    const filterRule = st =>
      st.name.toLowerCase().indexOf(this.state.filter.toLowerCase()) > -1;
    const filteredDecks = this.state.decks.filter(filterRule);

    return (
      <LessonCard
        iconClass="deck-bank"
        heading="Add Decks"
        subHeading="Add Decks to the Apostrophes Lesson Deck Bank"
        headerButtons={[
          <Button
            className={`add-btn`}
            onClick={() => console.log("Redirect to Deck Page")}
          >
            + Create New Deck
          </Button>
        ]}
        footerButtons={[
          <Button
            className="lesson-cancel-btn"
            onClick={() => this.props.onClose()}
          >
            Cancel Changes
          </Button>,
          <Button
            className="lesson-action-btn"
            onClick={() => this.props.addDecks()}
          >
            + Add to Deck Bank
          </Button>
        ]}
      >
        <Filter
          onChg={this.onChg}
          filter={this.state.filter}
          placeholder={"Search"}
        />
        <div className="items-bank-right-container">
            {filteredDecks.map(deck => (
              <div className="item">
                <div className="author-lesson-checkbox">
                  <Input type="checkbox" />
                  <span class="checkmark" />
                </div>

                <div className="item-card">
                  <Row>
                    <Col sm="2" md="2" className="item-label">
                    Deck Type:
                    </Col>
                    <Col xs="12" sm="9" md="9" className="item-desc">
                      <strong>{deck.type}</strong>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="2" md="2" className="item-label">
                      Deck Code:
                    </Col>
                    <Col xs="12" sm="9" md="9" className="item-desc">
                      {deck.code}
                      <a className="modal-link edit-deck" onClick={() => console.log("edit deck")} >Edit Deck</a>
                      <a  onClick={() => this.props.showPreview(deck)}>
                        <i className="screen-eye-icon" />
                      </a>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="2" md="2" className="item-label">
                      Deck Name
                    </Col>
                    <Col xs="12" sm="9" md="9" className="item-desc">
                    {deck.name}
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="2" md="2" className="item-label">
                      Tags:
                    </Col>
                    <Col xs="12" sm="9" md="9" className="item-desc">
                      {deck.tags}
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="2" md="2" className="item-label">
                      Nodes:
                    </Col>
                    <Col xs="12" sm="9" md="9" className="item-desc">
                      {deck.nodes}
                    </Col>
                  </Row>
                </div>
              </div>
            ))}
          </div>
      </LessonCard>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorLesson/AddDecks.js